import { defineMessages } from "react-intl";

import TourDescriptor from "@app/component/flows/types/TourDescriptor";
import ensureSettingsCategoryOpen from "@app/component/flows/utils/ensureSettingsCategoryOpen";

const messages = defineMessages({
  dataBasics1: {
    id: "guides.gettingStarted.checklist.dataBasics.step1",
    defaultMessage: "Import page",
  },
  dataBasics1Description: {
    id: "guides.gettingStarted.checklist.dataBasics.step1.description",
    defaultMessage: "You can use imports to quickly add data from CSV files.",
  },
  dataBasics2: {
    id: "guides.gettingStarted.checklist.dataBasics.step2",
    defaultMessage: "Integrations",
  },
  dataBasics2Description: {
    id: "guides.gettingStarted.checklist.dataBasics.step2.description",
    defaultMessage:
      "If you use a CRM system, you can configure the way data syncs on the Integrations page.",
  },
  dataBasics3: {
    id: "guides.gettingStarted.checklist.dataBasics.step3",
    defaultMessage: "Layouts",
  },
  dataBasics3Description: {
    id: "guides.gettingStarted.checklist.dataBasics.step3.description",
    defaultMessage:
      "You can create custom layouts for different record types and assign them to different teams or roles.",
  },
  dataBasics4: {
    id: "guides.gettingStarted.checklist.dataBasics.step4",
    defaultMessage: "Fields",
  },
  dataBasics4Description: {
    id: "guides.gettingStarted.checklist.dataBasics.step4.description",
    defaultMessage:
      "Or perhaps you need more fields? On the Manage Fields page you can create and edit fields, archive the columns you don’t need anymore, and configure field visibility.",
  },
  dataBasics5: {
    id: "guides.gettingStarted.checklist.dataBasics.step5",
    defaultMessage: "Groups",
  },
  dataBasics5Description: {
    id: "guides.gettingStarted.checklist.dataBasics.step5.description",
    defaultMessage: "Groups can be used to categorize records and share them conveniently.",
  },
  dataBasics6: {
    id: "guides.gettingStarted.checklist.dataBasics.step6",
    defaultMessage: "Territories",
  },
  dataBasics6Description: {
    id: "guides.gettingStarted.checklist.dataBasics.step6.description",
    defaultMessage:
      "Territories can be used for the same, except that records will automatically be put into a corresponding territory based on geography.",
  },
});

export const ownersDataBasicsTour: TourDescriptor = {
  id: "getting-started-owners-data-basics",
  steps: [
    {
      id: "import",
      description: messages.dataBasics1Description,
      onBefore: async () => {
        await ensureSettingsCategoryOpen("data");
      },
      position: "right",
      selector: "[data-menu-item=import]",
      title: messages.dataBasics1,
    },
    {
      id: "integrations",
      description: messages.dataBasics2Description,
      goToPathBefore: "/settings/organization/integrations",
      position: "right",
      selector: "[data-menu-item=integrations]",
      title: messages.dataBasics2,
    },
    {
      id: "layouts",
      description: messages.dataBasics3Description,
      goToPathBefore: "/settings/forms/create-forms",
      onBefore: async () => {
        await ensureSettingsCategoryOpen("forms-and-fields");
      },
      position: "right",
      selector: "[data-menu-item=layouts]",
      title: messages.dataBasics3,
    },
    {
      id: "schemas",
      description: messages.dataBasics4Description,
      goToPathBefore: "/settings/forms/manage-fields",
      position: "right",
      selector: "[data-menu-item=schemas]",
      title: messages.dataBasics4,
    },
    {
      id: "groups",
      description: messages.dataBasics5Description,
      goToPathBefore: "/map",
      selector: "[data-menu-item=groups]",
      title: messages.dataBasics5,
    },
    {
      id: "territories",
      description: messages.dataBasics6Description,
      selector: "[data-menu-item=territories]",
      title: messages.dataBasics6,
    },
  ],
};

export const managersDataBasicsTour: TourDescriptor = {
  id: "getting-started-managers-data-basics",
  steps: [
    {
      id: "groups",
      description: messages.dataBasics5Description,
      goToPathBefore: "/map",
      selector: "[data-menu-item=groups]",
      title: messages.dataBasics5,
    },
    {
      id: "territories",
      description: messages.dataBasics6Description,
      selector: "[data-menu-item=territories]",
      title: messages.dataBasics6,
    },
  ],
};
